import tochtApi from "../../../api/e-loket/tochtApi";
import geographyApi from "../../../api/e-loket/geographyApi";
import gemeenteApi from "../../../api/shared/gemeenteApi";
import moment from "moment";
import * as messages from "../../../constants/ToastrConstants";
import { showToastrError, showToastrWarning, showToastrSuccess } from "../../../util/toastr";
import { Landen } from "../../../constants/DomainConstants";
import { ValidationMessageTypes } from "../../../constants/ComponentConstants";
import GenerateGuid from "../../../util/guid";
import assign from "object-assign";
import { orderByPropertyName } from "../../../util/orderBy";
import FilesHelper from "../../common/FilesHelper";
import { formatFilesForSave } from "../../../components/common/FilesHelperUtil";

export default class UpdateTochtPageHelper {
	constructor(context, redirector) {
		this.context = context;
		this.redirector = redirector;
	}

	init() {
		const context = this.context;
		const ajaxActions = context.props.ajaxActions;

		const params = context.props.match.params;
		const modelId = params.modelId;
		const isEdit = params.isEdit || false;
		context.filesHelper = new FilesHelper(context, modelId);

		const returnUrl = decodeURIComponent(
			context.props.match.params.returnUrl
		);

		ajaxActions.started();
		gemeenteApi.getHoofdgemeenten()
			.then((response) => {
				ajaxActions.ended();
				this.processHoofdgemeenten(response);
				const { hash } = window.location;
				if (hash !== '') {
					// Push onto callback queue so it runs after the DOM is updated,
					// this is required when navigating from a different page so that
					// the element is rendered on the page before trying to getElementById.
					setTimeout(() => {
						const id = hash.replace('#', '');
						const element = document.getElementById(id);
						if (element) element.scrollIntoView();
					}, 0);
				}
			})
			.catch((ex) => {
				ajaxActions.failed();
				context.props.throwException(ex);
			});

		ajaxActions.started();
		tochtApi
			.get(modelId)
			.then(response => {
				ajaxActions.ended();
				this.processModel(response, false);
			})
			.catch(ex => {
				ajaxActions.failed();
				context.props.throwException(ex);
			});

		context.setState({
			modelId,
			isEdit,
			returnUrl
		});
	}

	addDeelnamePrijs() {
		const ajaxActions = this.context.props.ajaxActions;
		const tochtId = this.context.state.model.id;
		let deelnamePrijzen = this.context.state.model.deelnamePrijzen;

		ajaxActions.started();
		return tochtApi
			.getNewDeelnamePrijs(tochtId)
			.then(result => {
				ajaxActions.ended();
				let deelnamePrijs = result.data;
				deelnamePrijzen.push(deelnamePrijs);
				this.context.setState({
					model: Object.assign({}, this.context.state.model, {
						deelnamePrijzen: deelnamePrijzen
					}),
					hasUnsavedChanges: true,
					showAnbPopup: false
				});
			})
			.catch(ex => {
				ajaxActions.failed();
				context.props.throwException(ex);
			});
	}

	removeDeelnamePrijs(index, event) {
		const model = this.context.state.model;

		model.deelnamePrijzen.splice(index, 1);

		this.context.setState({
			model,
			hasUnsavedChanges: true,
			showAnbPopup: false
		});
	}

	changeDeelnamePrijs(index, event) {
		const value = event.target.value;
		const property = event.target.name.split("_")[0];
		const model = this.context.state.model;

		this.context.state.model.deelnamePrijzen[index][property] = value;

		this.context.setState({
			model,
			hasUnsavedChanges: true,
			showAnbPopup: false
		});
	}

	changeExtraOndersteuning(event) {
		const model = this.context.state.model;
		this.changeRadio(event);

		switch (event.target.name) {
			case "extraOndersteuningDoorANBGewenst":
				{
					model.extraOndersteuningDoorANBOmschrijving = null;
					break;
				}
			case "reclameInANBGebied":
				{
					model.omschrijvingGebiedReclame = null;
					break;
				}
			default:
				break;
		}

		this.context.setState({ model });
	}

	addLus() {
		const ajaxActions = this.context.props.ajaxActions;
		const tochtId = this.context.state.model.id;
		let lussen = this.context.state.model.lussen;

		ajaxActions.started();
		return tochtApi
			.getNewLus(tochtId)
			.then(result => {
				ajaxActions.ended();
				let lus = result.data;
				lussen.push(lus);
				this.context.setState({
					model: Object.assign({}, this.context.state.model, {
						lussen: lussen
					}),
					hasUnsavedChanges: true,
					showAnbPopup: false
				});
			})
			.catch(ex => {
				ajaxActions.failed();
				context.props.throwException(ex);
			});
	}

	removeLus(index, event) {
		const model = this.context.state.model;

		model.lussen.splice(index, 1);

		this.context.setState({
			model,
			hasUnsavedChanges: true,
			showAnbPopup: false
		});
	}

	changeLus(index, event) {
		const value = event.target.value;
		const property = event.target.name.split("_")[0];
		const model = this.context.state.model;

		model.lussen[index][property] = value;

		this.context.setState({
			model,
			hasUnsavedChanges: true,
			showAnbPopup: false
		});
	}

	addGemeente(index, event) {
		let gemeenten = this.context.state.model.gemeenten;

		let leegModel = { id: null };
		gemeenten.push(leegModel);
		this.context.setState({
			model: Object.assign({}, this.context.state.model, {
				gemeenten: gemeenten
			}),
			hasUnsavedChanges: true,
			showAnbPopup: false
		});
	}

	changeGemeente(index, event) {
		const value = event.target.value;
		const property = "id";
		const model = this.context.state.model;

		this.context.state.model.gemeenten[index][property] = value;

		this.context.setState({
			model,
			hasUnsavedChanges: true,
			showAnbPopup: false
		});
	}

	removeGemeente(index, event) {
		const model = this.context.state.model;

		model.gemeenten.splice(index, 1);

		this.context.setState({
			model,
			hasUnsavedChanges: true,
			showAnbPopup: false
		});
	}

	getGeoCoordinatesStart() {
		const context = this.context;
		const ajaxActions = this.context.props.ajaxActions;
		const model = this.context.state.model;

		let adres = {
			gemeenteId: model.startplaatsGemeente,
			postcodeId: model.startplaatsPostcode,
			landId: model.startplaatsLand,
			straat: model.startplaatsStraat,
			nummer: model.startplaatsHuisnummer
		};

		ajaxActions.started();
		return geographyApi
			.getCoordinatenForAdres(adres)
			.then(result => {
				ajaxActions.ended();

				model.startplaatsBreedtegraad = result.data.breedtegraad !== 0 ? result.data.breedtegraad : 51.0132;
				model.startplaatsLengtegraad = result.data.lengtegraad !== 0 ? result.data.lengtegraad : 4.3554;

				this.context.setState({
					model,
					hasUnsavedChanges: true,
					center: Object.assign({}, { lat: Number(model.startplaatsBreedtegraad), lng: Number(model.startplaatsLengtegraad) }),
					mapKey: GenerateGuid(),
					showAnbPopup: false
				});
			})
			.catch(ex => {
				ajaxActions.failed();
				context.props.throwException(ex);
			});
	}

	getGeoCoordinatesAankomst() {
		const context = this.context;
		const ajaxActions = this.context.props.ajaxActions;
		const model = this.context.state.model;

		let adres = {
			gemeenteId: model.aankomstGemeente,
			postcodeId: model.aankomstPostcode,
			landId: model.aankomstLand,
			straat: model.aankomstplaatsStraat,
			nummer: model.aankomstplaatsHuisnummer
		};

		ajaxActions.started();
		return geographyApi
			.getCoordinatenForAdres(adres)
			.then(result => {
				ajaxActions.ended();

				model.aankomstBreedtegraad = result.data.breedtegraad;
				model.aankomstLengtegraad = result.data.lengtegraad;

				this.context.setState({
					model,
					hasUnsavedChanges: true,
					showAnbPopup: false
				});
			})
			.catch(ex => {
				ajaxActions.failed();
				context.props.throwException(ex);
			});
	}

	save() {
		const model = this.context.state.model;
		if (model.startplaatsLand === Landen.BELGIE && !(model.startplaatsBreedtegraad && model.startplaatsLengtegraad))
			this.getGeoCoordinatesStart().then(() => this._save());
		else
			this._save();
	}

	_save() {
		const context = this.context;
		const ajaxActions = context.props.ajaxActions;

		let errors = null;
		let model = null;
		let hasUnsavedChanges = true;
		let scrollToTop = false;

		let modelToSave = this.context.state.model;

		context.filesHelper.commitSession();
		//todo rework documentsModel server side to avoid this
		let fileBaseUrl = this.context.filesHelper.getBaseFileLocation();
		let documentsForSave = formatFilesForSave(context.state.fileComponents, fileBaseUrl);

		ajaxActions.started();
		return tochtApi.save(modelToSave, documentsForSave).then((response) => {
			ajaxActions.ended();

			if(response.data.concurrencyException){
				model = assign({}, response.data.item, {});
				showToastrError(messages.MESSAGE_NOT_SAVED_CONCURRENCY_EXCEPTION);
			} else if(response.statusText !== "OK" && response.data.hasValidationErrors){

				errors = assign({}, response.data.validationResults);
				model = assign({}, response.data.item, {});
				showToastrError(messages.MESSAGE_VALIDATION_ERRORS);
			}
			else {
				if (Object.keys(response.data.validationResults).length !== 0) {
					model = assign({}, response.data.item);
					errors = assign({}, response.data.validationResults);
					showToastrWarning(messages.MESSAGE_VALIDATION_ERRORS_SAVED, true);
				}
				else {
					model = assign({}, response.data.item, {});
					errors = {};
					scrollToTop = true;
				}
				hasUnsavedChanges = false;

				showToastrSuccess(messages.MESSAGE_SAVED, true);
			}

			context.props.validatieStatussenLoaded(model.validatiestatusses);
			this.loadLayout(model);

			if (model.lussen)
				model.lussen = orderByPropertyName(model.lussen, "naam");

			if (model.showANBWarning)
				showToastrWarning("Dossiers die minder dan 35 dagen voor de tocht worden ingediend kunnen niet meer door ANB beoordeeld worden. De routes van deze tocht mogen niet door ANB gebied lopen. Gelieve je routes aan te passen.", true, true);

			if (model.showAWVWarning)
				showToastrWarning("Dossiers die minder dan 35 dagen voor de tocht worden ingediend kunnen niet meer door het Agentschap Wegen en Verkeer beoordeeld worden.	De routes van deze tocht mogen niet langs Gewestwegen/Autosnelwegen lopen of Gewestwegen kruisen. Gelieve je route aan te passen.", true, true);

			this.context.setState({
				errors: errors,
				model,
				validationMessageType: response.data.hasValidationErrors ? ValidationMessageTypes.ERROR : ValidationMessageTypes.WARNING,
				hasUnsavedChanges: hasUnsavedChanges,
				center: Object.assign({}, { lat: Number(model.startplaatsBreedtegraad), lng: Number(model.startplaatsLengtegraad) }),
				mapKey: GenerateGuid(),
				showErrors: true,
				showAnbPopup: model.showAnbPopup,
				scrollToTop: scrollToTop,
				shouldScrollToFirstError: true
			});
		})
			.catch((ex) => {
				ajaxActions.failed();
				context.props.throwException(ex);
			});
	}

	processModel(response) {
		const isValidated = response.data.validationResults ? true : false;
		const context = this.context;
		let model = isValidated ? response.data.item : response.data;

		if (model.lussen)
			model.lussen = orderByPropertyName(model.lussen, "naam");

		let validationResults = null;

		context.setState({
			model,
			errors: validationResults,
			center: Object.assign({}, { lat: Number(model.startplaatsBreedtegraad), lng: Number(model.startplaatsLengtegraad) }),
			mapKey: GenerateGuid()
		});

		this.loadLayout(model);
	}

	loadLayout(model) {
		const context = this.context;
		const datum = moment(model.datum).format("DD/MM/YYYY");
		const title = `${model.naam} ${datum}`;
		context.props.loadLayout(title, model.id, model.validatiestatusses, model.svlDossierId);
		context.props.validatieStatussenLoaded(model.validatiestatusses);
	}

	processHoofdgemeenten(response) {
		const context = this.context;

		let gemeenten = response.data.map(k => { return { value: k.hoofdaccountId, label: k.naam }; });

		context.setState({
			hoofdgemeenten: gemeenten
		});
	}

	change(event) {
		const value = event.target.value;
		const property = event.target.name;

		const model = this.context.state.model;
		model[property] = value;

		if (model.aankomstLand == Landen.BELGIE) {
			model.aankomstplaatsPostcodeBuitenland = null;
			model.aankomstplaatsGemeenteBuitenland = null;
		}
		else {
			model.aankomstPostcode = null;
			model.aankomstGemeente = null;
		}

		this.context.setState({
			model,
			hasUnsavedChanges: true,
			showAnbPopup: false
		});
	}

	changeStartplaats(event) {
		const value = event.target.value;
		const property = event.target.name;

		const model = this.context.state.model;
		model[property] = value;

		if (model.startplaatsLand == Landen.BELGIE) {
			model.startplaatsPostcodeBuitenland = null;
			model.startplaatsGemeenteBuitenland = null;
		}
		else {
			model.startplaatsPostcode = null;
			model.startplaatsGemeente = null;
		}

		model.startplaatsLengtegraad = null;
		model.startplaatsBreedtegraad = null;

		this.context.setState({
			model,
			hasUnsavedChanges: true,
			showAnbPopup: false
		});
	}

	changeRadio(event) {
		const value = event.target.value === "true" ? true : false;
		const property = event.target.name;

		const model = this.context.state.model;
		model[property] = value;

		this.context.setState({
			model,
			hasUnsavedChanges: true,
			showAnbPopup: false
		});
	}

	getErrorForProperty(propertyName) {
		const errors = this.context.state.errors;
		return errors && errors ? errors[propertyName] : null;
	}

	markerDragEnd(event, id) {
		const context = this.context;
		const state = context.state;
		const model = state.model;

		model.startplaatsBreedtegraad = event.target._latlng.lat;
		model.startplaatsLengtegraad = event.target._latlng.lng;

		this.context.setState({
			model
		});
	}

	confirmAnbPopup() {
		this.context.setState({
			showAnbPopup: false
		});
	}
}
